import { render, staticRenderFns } from "./AlipayConfig.vue?vue&type=template&id=076bf401&scoped=true"
import script from "./AlipayConfig.vue?vue&type=script&lang=js"
export * from "./AlipayConfig.vue?vue&type=script&lang=js"
import style0 from "./AlipayConfig.vue?vue&type=style&index=0&id=076bf401&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "076bf401",
  null
  
)

export default component.exports